@if (shouldShow()) {
	<span class="live-indicator" [ngClass]="flagClass()" [title]="title()">
		{{ label() }}
	</span>
}